import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { IBloc3 } from "../../../models/interfaces/INotice";
import ModalText from "./ModalText";
import ModalReader from "./ModalReader";

interface IProps {
    NoticeResult: IBloc3;
}

const Bloc3: React.FC<IProps> = ({ NoticeResult }) => {
  //Modal Text
  const [modalShowText, setModalShowText] = useState(false);
  const [modalName, setModalName] = useState<string>();
  const [modalText, setModalText] = useState<any>();
  
  //Modal Reader
  const [modalRShow, setModalRShow] = useState(false);
  const [modalRUrl, setModalRUrl] = useState<string>("");
  const [modalRName, setModalRName] = useState<string>();
  
  // Check if all properties of NoticeResult are empty, and if so, return null (render nothing)
  const isNoticeResultEmpty = 
    !NoticeResult?.extrait &&
    !NoticeResult?.quatriemeDeCouverture &&
    !NoticeResult?.biographie &&
    !NoticeResult?.tableDesMatieres &&
    !NoticeResult?.descriptionsEbook?.resumeEbook;

  if (isNoticeResultEmpty) {
    return null;
  }
  //A voir 
  const decodeHtmlEntities = (str: string) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
  };
  
  const decodedText = decodeHtmlEntities(NoticeResult.descriptionsEbook?.resumeEbook);
  

  return (
    <>
      <Card className="p-2 mt-1 mb-2">
        <Card.Body>
          {NoticeResult?.extrait && (
            <Card.Title style={{ textAlign: 'left' }}>
              <a
                  href="#"
                  onClick={() => {
                    setModalRUrl(NoticeResult.extrait);
                    setModalRShow(true);
                    setModalRName("Extrait");
                  }}
              >
                Extrait
              </a>
            </Card.Title>
          )}
          {NoticeResult?.quatriemeDeCouverture && (
            <Card.Title style={{ textAlign: 'left' }}>
              <a
                href="#"
                onClick={() => {
                  setModalText(NoticeResult.quatriemeDeCouverture);
                  setModalShowText(true);
                  setModalName("4ème de couverture");
                }}
                className="link-remove-style"
              >
                4ème de couverture
              </a>
            </Card.Title>
          )}
          {NoticeResult?.biographie && (
            <Card.Title style={{ textAlign: 'left' }}>
              <a
                href="#"
                onClick={() => {
                  setModalText(NoticeResult.biographie);
                  setModalShowText(true);
                  setModalName("Biographie");
                }}
                className="link-remove-style"
              >
                Biographie
              </a>
            </Card.Title>
          )}
          {NoticeResult?.tableDesMatieres && (
            <Card.Title style={{ textAlign: 'left' }}>
              <a
                href="#"
                onClick={() => {
                  setModalText(NoticeResult.tableDesMatieres);
                  setModalShowText(true);
                  setModalName("Table des matières");
                }}
                className="link-remove-style"
              >
                Table des matières
              </a>
            </Card.Title>
          )}
          {NoticeResult?.descriptionsEbook?.resumeEbook && (
            <Card.Title style={{ textAlign: 'left' }}>
              <a
                href="#"
                onClick={() => {
                  setModalText(decodedText);
                  setModalShowText(true);
                  setModalName("Résumé éditeur");
                }}
                className="link-remove-style"
              >
                Résumé éditeur 
              </a>
            </Card.Title>
          )}
        </Card.Body>
      </Card>
      <ModalText
        show={modalShowText}
        onHide={() => setModalShowText(false)}
        bodyText={modalText}
        headerModalText={modalName}
      />
      <ModalReader 
      show={modalRShow}
      handleClose={() => setModalRShow(false)}
      urlToRead={modalRUrl}
      headerText={modalRName}
      />
    </>
  );
};

export default Bloc3;
